import classNames from "classnames";
import { LuCircleCheck } from "react-icons/lu";

import { StepIndicatorProps } from "./types";

import "./styles.scss";

export const StepIndicator = ({ stepNumber, state }: StepIndicatorProps) => {
  const classnames = classNames("StepIndicator", {
    "StepIndicator--active": state === "active",
    "StepIndicator--completed": state === "completed",
    "StepIndicator--pending": state === "pending",
  });

  const getStepIndicatorContent = () => {
    if (state === "completed") {
      return (
        <LuCircleCheck
          className="StepIndicator__check"
          aria-hidden="true"
        />
      );
    }
    return stepNumber;
  };

  return (
    <span
      className={classnames}
      data-testid="step-indicator"
      aria-hidden="true"
    >
      {getStepIndicatorContent()}
    </span>
  );
};
